import { useCallback, useRef, useState } from 'react';

export default function useInvoiceNotifications() {
    const [notifications, setNotifications] = useState([]);
    const sequence = useRef(0);
    const notify = useCallback((message, tone = 'green', details = []) => {
        const notification = { id: ++sequence.current, message, tone, details };
        setNotifications(previous => [...previous, notification]);
    }, []);
    const dismissNotification = useCallback(id => {
        setNotifications(previous => previous.filter(item => item.id !== id));
    }, []);
    const clearNotifications = useCallback(() => setNotifications([]), []);
    return { notifications, notify, dismissNotification, clearNotifications };
}
